import { routerHistory } from '../../routing/routing-lib';

export default {
  goToInternalRoute: internalRoute => {
    const history = routerHistory.getHistory();
    history.push(internalRoute);
  },

  replaceInternalRoute: internalRoute => {
    const history = routerHistory.getHistory();
    let routeToNavigate = internalRoute;

    if (internalRoute && !internalRoute.startsWith('/')) {
      routeToNavigate = `/${internalRoute}`;
    }

    history.replace(routeToNavigate);
  },

  redirectToExternalLink: externalRoute => {
    if (externalRoute) {
      window.location.href = externalRoute;
    }
  }
};
